import NotificationView from 'src/sections/settings/notification/view';

export default function NotificationPage() {
  return <NotificationView />;
}
